import { ReactElement, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { isNumber } from '../../utils/math';

export interface ParamIntegerProps {
  paramKey: string;
  children: (param: number) => ReactElement;
  notFoundComponent: ReactElement;
}

export function ParamInteger({
  paramKey,
  children,
  notFoundComponent,
}: ParamIntegerProps) {
  const params = useParams<Record<string, string>>();

  const paramStr = params[paramKey];

  const param = useMemo(() => {
    if (isNumber(paramStr)) {
      return Number(paramStr);
    }
    return null;
  }, [paramStr]);

  if (!param) {
    return notFoundComponent;
  }

  return children(param);
}
